import request from '@/utils/request';
export function paymentList(data) {
  return request.post('admin/order/order-payment-list', data);
}
export function paymentDownload(data) {
  return request.post('admin/order/order-payment-download', data);
}
export function paymentDetail(data) {
  return request.post('admin/order/order-payment-detail', data);
}